import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { Spacing4, Spacing16 } from 'autogen/design-tokens/tokens';
import type { ProductTabContentBrandTeaserModel } from 'autogen/swagger/all';
import { ReadAboutTextAndLink } from 'autogen/translation-keys/trans-website-product-tabs';
import { format } from 'modules/helpers/strings';

const Wrapper = styled.div`
    padding-bottom: ${Spacing16};
`;

const Content = styled.div`
    padding-bottom: ${Spacing4};
`;

export default function ContentBrandTeaser({ ...props }: ProductTabContentBrandTeaserModel): JSX.Element {
    const { brandName, content, url } = props;
    const { t } = useTranslation();
    const link = format(t(ReadAboutTextAndLink))(url, brandName);

    return (
        <Wrapper>
            <Content dangerouslySetInnerHTML={{ __html: content }} />
            <span dangerouslySetInnerHTML={{ __html: link }} />
        </Wrapper>
    );
}
